import React, { useEffect,useState } from 'react'
import { Collapse, Table } from 'antd';

const EventFacillitator = ({  data }) => {

  const [facilitators, setFacilitators] = useState([]);
  const [expandIconPosition, setExpandIconPosition] = useState("start");

  const { Panel } = Collapse;

  const columns = [
    { title: "First Name", dataIndex: "name", key: "1", responsive: ["sm"] },
    { title: "Last Name", dataIndex: "surname", key: "2", responsive: ["sm"] },
    { title: "Email Address", dataIndex: "email", key: "3", responsive: ["sm"] },
  ];

  useEffect(() => {
    loadFacilitators()
  }, [])

  const loadFacilitators = () => {
    setFacilitators(data);
  }

  return (
    <>
      <Collapse key="1a" expandIconPosition={expandIconPosition} >
        <div>
          <Table
            dataSource={facilitators}
            columns={columns}
            rowKey={(x)=> x.email}
            bordered
            pagination={{ pageSize: 10 }}
          />
        </div>
      </Collapse>
    </>
  )
}

export default EventFacillitator